// extracted by mini-css-extract-plugin
export default {"pill":"status-pill-module__pill___2IlNl","openPill":"status-pill-module__openPill___3UXUA","closedPill":"status-pill-module__closedPill___3mbnU"};